import {
  MemSourceProjectLinkDto,
  TaskBaseDto,
  TaskBaseFileDto,
  FeedbackFormTypeEnum,
  FeedbackSubmissionStatusEnum,
  QaFormRequirementEnum,
} from "api/api.typing";
import { useCatToolsStore } from "store/useCatToolsStore";

// Re-export enums for easier imports
export { FeedbackFormTypeEnum, FeedbackSubmissionStatusEnum, QaFormRequirementEnum };

export type TaskBaseFields = keyof TaskBase;

export interface TaskBase extends Omit<TaskBaseDto, "id" | "unit" | "secondUnit"> {
  id: string; // convert to string, easier to manage in react-router
  searchFields: string;
  unit: string;
  secondUnit: string;
  supplierContactName: string;
  tempoChatId: number | null;
  chatEnabled: boolean;
}

export type TaskBaseTypes = "task" | "offer" | "request";

export type TaskBaseFile = TaskBaseFileDto;

export type MemSourceProjectLink = MemSourceProjectLinkDto;

export interface CatSteps {
  totalSegments: number;
  doneSegments: number;
  progression: number;
  details: Array<{
    documentName: string;
    totalSegments: number;
    doneSegments: number;
    progression: number;
  }>;
}

// Consumers must call useCatToolsStore.getState().loadCatTools() once at app start or before usage
export const getCatToolName = (catToolId: number): string | null =>
  useCatToolsStore.getState().getCatToolName(catToolId);

export const PHRASE_CAT_TOOL_ID = 2;
export const XTM_CAT_TOOL_ID = 3;
export const TRANSLATE5_CAT_TOOL_ID = 5;
export interface QAFormType {
  ratings: Array<{ key: number; value: string }>;
  titles: Array<{ id: number; description: string; details: string }>;
}

export type TaskFileUploadType = "delivery" | "notes";

export enum QualitySurveyRatingStarAppreciation {
  OneStar = 137,
  TwoStars = 138,
  ThreeStars = 139,
  FourStars = 140,
  FiveStars = 141,
}
